import axiosInstance from '@/utils/api.js'

var state = {
  messages: [],
  messages_paged: [],
  templates: [],
  default_templates: []
}

var getters = {
  NOTIFICATIONS_MESSAGES: (state) => {
    return state.messages
  },
  NOTIFICATIONS_MESSAGES_COUNT: (state) => {
    return state.messages.length
  },
  NOTIFICATIONS_TEMPLATES: (state) => {
    return state.templates
  },
  NOTIFICATIONS_MESSAGES_PAGED: (state) => {
    return state.messages_paged
  },
  NOTIFICATIONS_TEMPLATES_COUNT: (state) => {
    return state.templates.length
  },
  NOTIFICATIONS_TEMPLATES_DEFAULT: (state) => {
    return state.default_templates
  }
}

var mutations = {
  SET_NOTIFICATIONS_MESSAGES: (state, payload) => {
    state.messages = payload
  },
  SET_NOTIFICATIONS_MESSAGES_PAGED: (state, payload) => {
    state.messages_paged = payload
  },
  SET_NOTIFICATIONS_TEMPLATES: (state, payload) => {
    state.templates = payload
  },
  SET_NOTIFICATIONS_TEMPLATES_DEFAULT: (state, payload) => {
    state.default_templates = payload
  }
}

var actions = {
  GET_NOTIFICATIONS_MESSAGES: async (context, payload) => {
    let result = await axiosInstance.get('/users/notification_messages')

    if (result.status === 200) {
      context.commit('SET_NOTIFICATIONS_MESSAGES', result.data)
    }
  },
  GET_NOTIFICATIONS_MESSAGES_PAGED: async (context, payload) => {
    let result = await axiosInstance.get('users/notification_messages_paged?filter=' + payload.filter + '&per_page=' + payload.per_page + '&page=' + payload.page)
    if (result.status === 200) {
      context.commit('SET_NOTIFICATIONS_MESSAGES_PAGED', result.data)
    }
  },
  GET_NOTIFICATIONS_TEMPLATES: async (context, payload) => {
    let result = await axiosInstance.get('/users/notification_messages_templates')

    if (result.status === 200) {
      context.commit('SET_NOTIFICATIONS_TEMPLATES', result.data)
    }
  },
  GET_NOTIFICATIONS_TEMPLATES_DEFAULT: async (context, payload) => {
    let result = await axiosInstance.get('/users/notification_messages_templates_default')

    if (result.status === 200) {
      context.commit('SET_NOTIFICATIONS_TEMPLATES_DEFAULT', result.data)
    }
  },
  UPDATE_NOTIFICATION_TEMPLATE: async (context, payload) => {
    let result = await axiosInstance.put('/users/notification_messages_templates', payload)

    if (result.status === 200) {
      let result = await axiosInstance.get('/users/notification_messages_templates')

      if (result.status === 200) {
        context.commit('SET_NOTIFICATIONS_TEMPLATES', result.data)
      }
    }
  },
  ADD_NOTIFICATION_TEMPLATE: async (context, payload) => {
    let result = await axiosInstance.post('/users/notification_messages_templates', payload)

    if (result.status === 200) {
      let result = await axiosInstance.get('/users/notification_messages_templates')

      if (result.status === 200) {
        context.commit('SET_NOTIFICATIONS_TEMPLATES', result.data)
      }
    }
  },
  DELETE_NOTIFICATION_TEMPLATE: async (context, payload) => {
    let result = await axiosInstance.delete('/users/notification_messages_template?id=' + payload)

    if (result.status === 200) {
      let result = await axiosInstance.get('/users/notification_messages_templates')

      if (result.status === 200) {
        context.commit('SET_NOTIFICATIONS_TEMPLATES', result.data)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/notifications.js